import React, { ReactElement } from 'react';
import { ColumnInstance } from 'react-table';
import { Flex } from 'rebass/styled-components';

import { FloatLabelInput, ButtonGroup } from 'ui/patterns';

import Icon from 'assets/icons';
import { TableHeaderType } from './customRecordsTypes';

export default function TableHeader(props: TableHeaderType): ReactElement {
  const onChangeText = (value: string) => {
    props.headerUpdateCallBack &&
      props.headerUpdateCallBack({ columnId: props.column.id, value });
  };

  const onSortChange = () => {
    props.handleSortChange && props.handleSortChange(props.column.id);
  };

  return (
    <Flex>
      <FloatLabelInput
        style={{ flexGrow: '1' }}
        label={props.column.id}
        onChangeText={onChangeText}
        value={
          (props.columnsSearch && props.columnsSearch[props.column.id]) || ''
        }
      />
      <ButtonGroup onClick={onSortChange}>
        {props.sortedItem?.sortKey !== props.column.id && (
          <Icon.Sort title="Sort" />
        )}
        {props.sortedItem?.sortKey === props.column.id &&
          props.sortedItem?.sortOrder === 'asc' && <Icon.SortUp title="Sort" />}
        {props.sortedItem?.sortKey === props.column.id &&
          props.sortedItem?.sortOrder === 'desc' && (
            <Icon.SortDown title="Sort" />
          )}
      </ButtonGroup>
    </Flex>
  );
}
